import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
    Grid,
    makeStyles,
    DialogTitle,
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
    Button,
    InputAdornment
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
} from 'mui-rff';
import { Form, Field } from 'react-final-form';
import DateFnsUtils from '@date-io/date-fns';
import * as logger from '../../../logger';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import S3Uploader from '../s3Uploader/s3Uploader';
import { gstInfoElr, addElr, editElr, getTripDetailsV3 } from '../../../store/actions/tripActionCreator';
import StateSelectionDialog from '../Dialog/StateSelectionDialog';
import TextInputState from '../Inputs/TextInputState';
import Alert from '@material-ui/lab/Alert';
import { isFunction } from '../../../utils/utils';

const useStyles = makeStyles((theme) => ({

    dialogTitleV1: {
        paddingLeft: 30,
        paddingRight: 18,
        paddingTop: 14,
        paddingBottom: '14px !important',
        '& .MuiTypography-root': {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }
    },
    closeButton: {
        color: '#9ea0a5'
    },
    divTitle: {
        fontSize: 20,
        fontWeight: 500
    },
    paper1: {
        borderRadius: 8
    },
    paperWidth: {
        width: 460,
        maxWidth: 460
    },
    daV1: {
        paddingTop: 21,
        paddingRight: 30,
        paddingBottom: '21px !important'
    },
    closeButtonV1: {
        borderRadius: 4,
        textTransform: 'capitalize',
        fontSize: 14,
        fontWeight: 500,
        paddingLeft: 19.5,
        paddingRight: 19.5,
        paddingTop: 7,
        paddingBottom: 7,
        backgroundImage: 'linear-gradient(to top, #f6f7f9, #ffffff) !important',
        marginRight: 16,
        '&:hover': {
            backgroundImage: 'linear-gradient(to top, #f6f7f9, #ffffff) !important'
        }
    },
    confirmButton: {
        borderRadius: 4,
        backgroundColor: '#5170f0',
        color: 'white',
        textTransform: 'capitalize',
        fontSize: 14,
        fontWeight: 500,
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 35,
        paddingRight: 35,
        '&:hover': {
            backgroundColor: '#5170f0'
        }
    },
    divTitleV1: {
        color: '#6b778c',
        fontSize: 12
    },
    divTitleV2: {
        color: '#6b778c',
        fontSize: 12,
        marginTop: 4
    },
    marginV1: {
        marginTop: 6,
    },
    textFieldV1: {
        marginTop: 6,
        "& .MuiInputBase-input": {
            paddingTop: '8.5px',
            paddingBottom: '8.5px',
            textTransform: 'uppercase'
        }
    },
    textFieldV2: {
        marginTop: 6,
        "& .MuiInputBase-input": {
            paddingTop: '8.5px',
            paddingBottom: '8.5px',
            textTransform: 'capitalize'
        }
    },
    textFieldV3: {
        marginTop: 6,
        "& .MuiInputBase-input": {
            paddingTop: '8.5px',
            paddingBottom: '8.5px'
        }
    },
    textFieldV4: {
        marginTop: 6,
        "& .MuiInputBase-input": {
            paddingTop: '8.5px',
            paddingBottom: '8.5px',
            textTransform: 'capitalize'
        }
    },
    divV1: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 16
    },
    widthV1: {
        width: '48%'
    },
    iconV1: {
        color: 'rgba(0, 0, 0, 0.54)'
    },
    mtV1: {
        marginTop: 16
    },
    dialogContentV1: {
        paddingLeft: 30,
        paddingRight: 30,
        paddingTop: 24
    },
    imgV1: {
        width: 96,
        height: 96,
        borderRadius: 8,
        objectFit: 'cover',
        border: '2px solid lightgrey'
    }
}));

const AddCompanyDetailsDialog = ({ open,selectedTrip,selectedLr,journey,updateJourney, onClose, onConfirm, trip, user, dispatchAddElr, dispatchGstInfoElr, edit, elrIdValue, elrDetailsData, dispatchEditElr, dispatchTripDetailsAction }) => {

    let submit;
    const classes = useStyles();

    const tripId = selectedTrip && selectedTrip.id ? selectedTrip.id : "";

    const [dialogOpen, setDialogOpen] = useState(open);

    const [profilePhoto, setProfilePhoto] = useState(elrDetailsData && elrDetailsData.logo_link ? elrDetailsData.logo_link : "");
    const [gstNumberValue, setGstNumberValue] = useState(elrDetailsData && elrDetailsData.gst_number ? elrDetailsData.gst_number : "");
    const [companyNameValue, setCompanyNameValue] = useState(user && user.userInfo && user.userInfo.companyName ? user.userInfo.companyName : "");
    const [panNumberValue, setPanNumberValue] = useState("");
    const [companyAddress1Value, setCompanyAddress1Value] = useState("");
    const [companyAddress2Value, setCompanyAddress2Value] = useState("");
    const [stateName, setStateName] = useState("");
    const [pinCodeValue, setPinCodeValue] = useState("");
    const [mobileNumberValue, setMobileNumberValue] = useState(user && user.userInfo && user.userInfo.contactNumber ? user.userInfo.contactNumber : "");
    const [emailValue, setEmailValue] = useState("");

    const [gstDetails, setGstDetails] = useState({});
    const [stateDialog, setStateDialog] = useState(false);

    const [checkFileType, setCheckFileType] = useState(false);
    const [sizeFlag, setSizeFlag] = useState(false);

    const initialValues = {
        gstNumber: gstNumberValue,
        panNumber: panNumberValue,
        companyName: companyNameValue,
        companyAddress1: companyAddress1Value,
        companyAddress2: companyAddress2Value,
        state: stateName,
        pinCode: pinCodeValue,
        mobileNumber: mobileNumberValue ? (mobileNumberValue.replace(/(\d{5})(\d{5})/, "$1-$2")).trim() : "",
        email: emailValue
    }

    useEffect(() => {

        if (trip && trip.elrGstInfo) {
            setGstDetails(trip.elrGstInfo);
            setCompanyAddress1Value(trip.elrGstInfo.address_line_1);
            setCompanyAddress2Value(trip.elrGstInfo.address_line_2);
            setCompanyNameValue(trip.elrGstInfo.name);
            setPanNumberValue(trip.elrGstInfo.pan_number);
            setPinCodeValue(trip.elrGstInfo.pincode);
            setStateName(trip.elrGstInfo.state);
        }

    }, [trip.elrGstInfo]);

    useEffect(() => {

        if (edit && elrDetailsData) {
            setGstNumberValue(elrDetailsData.gst_number ? elrDetailsData.gst_number : "");
            setPanNumberValue(elrDetailsData.pan_number ? elrDetailsData.pan_number : "");
            setCompanyNameValue(elrDetailsData.name ? elrDetailsData.name : "");
            setCompanyAddress1Value(elrDetailsData.address_line_1 ? elrDetailsData.address_line_1 : "");
            setCompanyAddress2Value(elrDetailsData.address_line_2 ? elrDetailsData.address_line_2 : "");
            setStateName(elrDetailsData.state ? elrDetailsData.state : "");
            setPinCodeValue(elrDetailsData.pincode ? elrDetailsData.pincode : "");
            setMobileNumberValue(elrDetailsData.contact_number ? elrDetailsData.contact_number.replace(/(\d{5})(\d{5})/, "$1-$2") : "");
            setEmailValue(elrDetailsData.email ? elrDetailsData.email : "");
        }

    }, []);

    const handleClose = () => {
        setDialogOpen(false);
        setGstDetails({});
        onClose();
    }

    const handleAddExpensePhoto = (file) => {
        setProfilePhoto(file);
    }

    const handleGstNumberInfo = (gstNumber) => {

        setGstNumberValue(gstNumber);

        let config = JSON.parse(localStorage.getItem("USER_APP_CONFIG"));

        let gstValidation = config && config.gstRegex ? new RegExp(config.gstRegex) : "";
        let gstUpperCase = gstNumber ? (gstNumber).toUpperCase() : "";

        if (gstNumber && (gstValidation.test(gstUpperCase))) {
            dispatchGstInfoElr(gstUpperCase,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Add Company Details Dialog Dweb', 'Get GST info elr successfull');
                    }
                },
                () => {
                    logger.log('Add Company Details Dialog Dweb', 'Get GST info elr failed');
                }
            );
        }
    }

    const handleInvalidUpload = (values) => {
        if (values.checkFileType) {
            setCheckFileType(true);
        }
        if (values.sizeFlag) {
            setSizeFlag(true);
        }
    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div>
                            <Grid
                                container
                                spacing={1}
                                direction="column"
                                justify="flex-start"
                                alignItems="center"
                            >
                                {profilePhoto &&
                                    <Grid item direction="column">
                                        <div className="S3Uploader-image-margin">

                                            <div className="S3Uploader-image-div">
                                                <img className={classes.imgV1} src={profilePhoto} alt="fileUpload" />
                                                <S3Uploader toggle={true} directoryName={"dweb-images/CompanyDetails"} handleFile={handleAddExpensePhoto} fromAddCompanyDetailsDialogEdit={true} id="addCompanyDetailEdit" displayErrorBelow={handleInvalidUpload} displayErrorMessageBelow={true} />
                                            </div>

                                        </div>
                                    </Grid>}
                                {!profilePhoto &&
                                    <Grid item>
                                        <S3Uploader toggle={true} handleFile={handleAddExpensePhoto} fromAddCompanyDetailsDialog={true} id="addCompanyDetails" displayErrorBelow={handleInvalidUpload} displayErrorMessageBelow={true} />
                                    </Grid>
                                }
                            </Grid>
                        </div>
                        <div>
                            {checkFileType &&
                                <Alert severity="error" className="mtV1">Please select only .jpg, .jpeg and .png files</Alert>
                            }
                            {sizeFlag &&
                                <Alert severity="error" className="mtV1">File size must be below 5MB.</Alert>
                            }
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>My GST Number</div>
                            <TextInputState
                                placeholder="GST Number"
                                name="gstNumber"
                                variant="outlined"
                                size="small"
                                className={classes.textFieldV1}
                                onChange={(e) => handleGstNumberInfo(e.target.value)}
                            />
                            <div className={classes.divTitleV2}>GST No. auto-fills Name and Address</div>
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>PAN Number</div>
                            <TextInputState
                                placeholder="PAN Number"
                                name="panNumber"
                                variant="outlined"
                                size="small"
                                className={classes.textFieldV1}
                                onChange={(e) => setPanNumberValue(e.target.value)}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>Company Name*</div>
                            <TextInputState
                                placeholder="Company Name"
                                name="companyName"
                                variant="outlined"
                                size="small"
                                className={classes.textFieldV2}
                                onChange={(e) => setCompanyNameValue(e.target.value)}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>Company Address Line 1</div>
                            <TextInputState
                                placeholder="Address Line 1"
                                name="companyAddress1"
                                variant="outlined"
                                size="small"
                                className={classes.textFieldV3}
                                onChange={(e) => setCompanyAddress1Value(e.target.value)}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>Company Address Line 2</div>
                            <TextInputState
                                placeholder="Address Line 2"
                                name="companyAddress2"
                                variant="outlined"
                                size="small"
                                className={classes.textFieldV3}
                                onChange={(e) => setCompanyAddress2Value(e.target.value)}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.divV1}>
                            <div className={classes.widthV1}>
                                <div className={classes.divTitleV1}>State</div>
                                <TextField
                                    placeholder="State"
                                    name="state"
                                    variant="outlined"
                                    size="small"
                                    className={classes.textFieldV4}
                                    onClick={() => handleStateSelect()}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <KeyboardArrowDownIcon className={classes.iconV1} />
                                            </InputAdornment>
                                        )
                                        // readonly: true
                                    }}
                                    inputProps={{
                                        readOnly: true
                                    }}
                                />
                            </div>
                            <div className={classes.widthV1}>
                                <div className={classes.divTitleV1}>Pincode</div>
                                <TextInputState
                                    placeholder="Pincode"
                                    name="pinCode"
                                    variant="outlined"
                                    size="small"
                                    className={classes.textFieldV3}
                                    onChange={(e) => setPinCodeValue(e.target.value)}
                                />
                            </div>
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>Mobile Number*</div>
                            <TextInputState
                                placeholder="Mobile Number"
                                name="mobileNumber"
                                variant="outlined"
                                size="small"
                                className={classes.textFieldV3}
                                fieldProps={{
                                    parse: value => value ? (value.replace(/(\d{5})(\d{5})/, "$1-$2")).trim() : ""
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            +91
                                        </InputAdornment>
                                    ),
                                }}
                                onChange={(e) => setMobileNumberValue(e.target.value)}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>E-mail</div>
                            <TextInputState
                                placeholder="E-mail"
                                name="email"
                                variant="outlined"
                                size="small"
                                className={classes.textFieldV3}
                                onChange={(e) => setEmailValue(e.target.value)}
                            />
                        </div>
                    </>
                )
            }
        ]
    }

    const handleStateSelect = () => {
        setStateDialog(true);
    }

    const validate = values => {

        let config = JSON.parse(localStorage.getItem("USER_APP_CONFIG"));

        let gstValidation = config && config.gstRegex ? new RegExp(config.gstRegex) : "";
        let panValidation = config && config.panRegex ? new RegExp(config.panRegex) : "";
        let number = values.mobileNumber ? /^[5-9]{1}[0-9]{9}$/.test(values.mobileNumber.replace("-", "")) : "";
        let emailValidation = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        let gstUpperCase = values.gstNumber ? (values.gstNumber).toUpperCase() : "";
        let panUpperCase = values.panNumber ? (values.panNumber).toUpperCase() : "";
        let pinCodeValidation = config && config.pincodeRegex ? new RegExp(config.pincodeRegex) : "";


        const errors = {};

        if (values.gstNumber && (!gstValidation.test(gstUpperCase))) {
            errors.gstNumber = "Please enter valid GST number"
        }
        if (values.panNumber && (!panValidation.test(panUpperCase))) {
            errors.panNumber = "Please enter valid PAN number."
        }
        if (!values.companyName) {
            errors.companyName = "Please enter your valid company name."
        }
        if (values.pinCode && (!pinCodeValidation.test(values.pinCode))) {
            errors.pinCode = "Please enter valid pin code."
        }
        if (!values.mobileNumber || !number) {
            errors.mobileNumber = "Please enter valid 10-digit mobile number."
        }
        if (values.email && !emailValidation.test(String(values.email).toLowerCase())) {
            errors.email = "Please enter valid email."
        }

        return errors;

    }

    const onSubmit = values => {

        let companyNameArray = values.companyName.split(" ");
        let companyNameCapitalize = [];

        if (companyNameArray && companyNameArray.length > 0) {
            companyNameArray.forEach((value) => {
                if (value) {
                    companyNameCapitalize.push((value.charAt(0).toUpperCase()) + value.slice(1));
                }
            })
        }

        const companyDetailsData = {
            trip_id: tripId,
            company_details: {
                address_line_1: values.companyAddress1 ? values.companyAddress1 : "",
                address_line_2: values.companyAddress2 ? values.companyAddress2 : "",
                contact_number: values.mobileNumber ? values.mobileNumber.replace("-", "") : "",
                email: values.email ? values.email : "",
                gst_number: values.gstNumber ? (values.gstNumber).toUpperCase() : "",
                name: companyNameCapitalize && companyNameCapitalize.length > 0 ? (companyNameCapitalize.join(" ")).trim() : "",
                pan_number: values.panNumber ? (values.panNumber).toUpperCase() : "",
                pincode: values.pinCode ? values.pinCode : "",
                state: values.state ? values.state : "",
                logo_link: profilePhoto ? profilePhoto : ""
            }
        }

        if (edit && elrIdValue) {

            dispatchEditElr(elrIdValue, companyDetailsData,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Add Company Details Dialog', 'Edit Elr successfull');
                        onConfirm();
                        setDialogOpen(false);
                    }
                },
                () => {
                    logger.log('Add Company Details Dialog', 'Edit Elr failed');
                }
            )

        } else {
            dispatchAddElr(companyDetailsData,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Add Company Details Dialog Dweb', 'Add ELR Successfull');
                        
                        if (isFunction(updateJourney) && journey && journey.id) {
                            updateJourney(journey.id)
                            onConfirm();
                            setDialogOpen(false);
                        }
                    }
                },
                () => {
                    logger.log('Add Company Details Dialog Dweb', 'Add ELR Failed');
                }
            )
        }

    }

    const handleStateDialogClose = () => {
        setStateDialog(false);
    }

    const handleSelectedState = (value) => {
        setStateName(value);
        setStateDialog(false);
    }

    return (
        <>
            <Dialog fullWidth={true} maxWidth={'sm'}
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogOpen} classes={{ paper: classes.paper1, paperWidthSm: classes.paperWidth }}>

                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divTitle}>
                        Add Company Details
                    </div>
                    <IconButton onClick={() => { handleClose() }} className={classes.closeButton}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers className={classes.dialogContentV1}>
                    <Form
                        onSubmit={onSubmit}
                        keepDirtyOnReinitialize
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                    {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                                </form>
                            )
                        }}
                    />
                </DialogContent>

                <DialogActions className={classes.daV1}>
                    <Button variant="contained" className={classes.closeButtonV1} onClick={() => { handleClose() }}>
                        Close
                    </Button>
                    <Button variant="contained" className={classes.confirmButton} type="submit"
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>

            </Dialog>

            {stateDialog && <StateSelectionDialog open={stateDialog} onClose={handleStateDialogClose} onSelect={handleSelectedState} />}
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGstInfoElr: (gstNumber, onSuccess, onFailure) => {
        dispatch(gstInfoElr(gstNumber, onSuccess, onFailure))
    },
    dispatchAddElr: (companyDetailsData, onSuccess, onFailure) => {
        dispatch(addElr(companyDetailsData, onSuccess, onFailure))
    },
    dispatchEditElr: (companyDetailsData, onSuccess, onFailure) => {
        dispatch(editElr(companyDetailsData, onSuccess, onFailure))
    },
    dispatchTripDetailsAction: (tripId, onSuccess, onError) => {
        dispatch(getTripDetailsV3(tripId, onSuccess, onError))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(AddCompanyDetailsDialog);